var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('fdw-odds-comparison',{attrs:{"client":"114","league":"nfl","state":"WORLD"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }